import { useTranslation } from 'react-i18next'
import { Head } from '#/components/head'
import { Text } from '#/components/ui/typography'


export default function AccountLoading() {
  const { t } = useTranslation([ 'settings' ])

  return (
    <div className="w-full">

      <Head title={t('account.page_title')} />

      <Text>{t('account.loading')}</Text>

    </div>
  )
}
